/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Permissions_Select_GroupsInputs */

const en_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select groups that can access this guide:`)
};

const fr_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez les groupes qui peuvent accéder à ce guide :`)
};

const de_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie Gruppen aus, die auf diesen Leitfaden zugreifen können:`)
};

const it_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona i gruppi che possono accedere a questa guida:`)
};

const ru_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группы, которым доступен этот справочник:`)
};

const es_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione grupos que pueden acceder a esta guía:`)
};

const zh_cn2_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择可以访问本指南的群体：`)
};

const ja_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このガイドにアクセスできるグループを選択してください:`)
};

const hi_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन समूहों का चयन करें जो इस मार्गदर्शिका तक पहुंच सकते हैं:`)
};

const pt_pt2_knp_manager_permissions_select_groups = /** @type {(inputs: Knp_Manager_Permissions_Select_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os grupos que podem acessar este guia:`)
};

/**
* | output |
* | --- |
* | "Select groups that can access this guide:" |
*
* @param {Knp_Manager_Permissions_Select_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_select_groups = /** @type {((inputs?: Knp_Manager_Permissions_Select_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_Select_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_permissions_select_groups(inputs)
	if (locale === "de") return de_knp_manager_permissions_select_groups(inputs)
	if (locale === "it") return it_knp_manager_permissions_select_groups(inputs)
	if (locale === "ru") return ru_knp_manager_permissions_select_groups(inputs)
	if (locale === "es") return es_knp_manager_permissions_select_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_permissions_select_groups(inputs)
	if (locale === "ja") return ja_knp_manager_permissions_select_groups(inputs)
	if (locale === "hi") return hi_knp_manager_permissions_select_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_permissions_select_groups(inputs)
	return en_knp_manager_permissions_select_groups(inputs)
});